import {
	TRIGGER_SET_SEND_MONEY_TRANSACTION_STATUS_DETAILS,
	TRIGGER_CLEAR_SEND_MONEY_TXN_DETAILS,
} from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const SendMoneyTxnStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_SET_SEND_MONEY_TRANSACTION_STATUS_DETAILS:
			return {
				...state,
				...action.data,
			};

		case TRIGGER_CLEAR_SEND_MONEY_TXN_DETAILS:
			return {};
		default:
			return state;
	}
};

export default SendMoneyTxnStatusReducer;
